// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__rOfyD","container":"styles_container__1nxJD"};